export function initHeaderPanel(){

    let activeToggle = null;

    function showHeaderPanel(panel, toggle) {
        panel.classList.add("is-open");
        toggle.classList.add("is-active");
        toggle.setAttribute("aria-expanded", "true");
        document.body.classList.add("is-headerpanelopen");
        activeToggle = toggle;

        if (panel.classList.contains("dcHeaderPanelSearch")) {
            const searchInput = panel.querySelector(".dcSearchbar input");
            if (searchInput) {
                setTimeout(() => searchInput.focus(), 300);
            }
        }
    }

    function hideAllHeaderPanels(){
        const openPanels = document.querySelectorAll(".dcHeaderPanel.is-open");
        const activeToggles = document.querySelectorAll(".js-toggleHeaderPanel.is-active");

        if (openPanels.length === 0 && activeToggles.length === 0) {
            return;
        }

        for(const panel of openPanels){
            panel.classList.remove("is-open");
        }
        for(const panelToggle of activeToggles){
            panelToggle.classList.remove("is-active");
            panelToggle.setAttribute("aria-expanded", "false");
        }
        document.body.classList.remove("is-headerpanelopen");

        if (activeToggle) {
            activeToggle.focus();
            activeToggle = null;
        }
    }

    document.addEventListener("keydown", function(event) {
        if (event.key === "Escape") {
            hideAllHeaderPanels();
        }
    });

    document.addEventListener("click", function(event) {
        const openPanels = document.querySelectorAll(".dcHeaderPanel.is-open");
        if (openPanels.length === 0) return;

        let clickedInside = false;
        for (const panel of openPanels) {
            if (panel.contains(event.target)) {
                clickedInside = true;
                break;
            }
        }

        if (!clickedInside) {
            hideAllHeaderPanels();
        }
    });

    const toggles = document.querySelectorAll(".js-toggleHeaderPanel");

    for(const headerPanelToggle of toggles){
        headerPanelToggle.setAttribute("aria-expanded", "false");
        const panel = document.getElementById(headerPanelToggle.dataset.toggleHeaderPanel);

        headerPanelToggle.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (headerPanelToggle.classList.contains("is-active")) {
                hideAllHeaderPanels();
            } else {
                hideAllHeaderPanels();
                if (panel) {
                    showHeaderPanel(panel, headerPanelToggle);
                }
            }
        });
    }
}